import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/card';
import { useAuth } from '../../context/AuthContext';
import { loanFlowService } from '../../services/api';
import { Loader2 } from 'lucide-react';

const LoanProcessing = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    processFlow();
  }, []);

  const processFlow = async () => {
    try {
      const flow = await loanFlowService.getByClient(user.id);
      if (flow) {
        await loanFlowService.update(flow.id, {
          currentStep: 'processing'
        });
      }

      // Simulate processing time
      setTimeout(() => {
        navigate('/client/loan-flow/success');
      }, 3000);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#E3F2FD' }}>
      {/* Header */}
      <div className="bg-white border-b border-gray-200 py-4 px-8">
        <div className="text-2xl font-bold">
          <span style={{ color: '#8B5CF6' }}>S2</span>
          <span className="text-gray-700">finco</span>
        </div>
      </div>

      {/* Banner */}
      <div className="bg-gray-800 text-white text-center py-2 text-sm">
        Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager.
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Card className="p-12 bg-white shadow-xl text-center">
          <div className="mb-8">
            <Loader2 className="h-20 w-20 animate-spin mx-auto" style={{ color: '#8B5CF6' }} />
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            La récupération de votre justificatif bancaire est en cours
          </h1>
          
          <p className="text-gray-600 text-lg mb-8">
            Veuillez patienter quelques instants...
          </p>

          <div className="bg-purple-50 p-6 rounded-lg">
            <p className="text-sm text-gray-700">
              🔒 Vos données sont sécurisées et chiffrées
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default LoanProcessing;
